module.exports = __webpack_public_path__ + "static/media/waldemar-brandt-U3Ptj3jafX8-unsplash.22d32718.jpg";